import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomeCate(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { title, prods, langs } = props;

  let cates = JSON.parse(localStorage.getItem('category'))
    ? JSON.parse(localStorage.getItem('category'))
    : [];

  const goCatePage = (catename, cateID) => {
    history.push(`/machineUI/category/cate/${catename}/${cateID}`);
  };

  cates = cates?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const result = cates.map((prod, i) => {
    const name = prod.name[langs] && prod.name[langs] !== '' ? prod.name[langs] : prod.name?.en;
    return (
      <div
        className="home-cate-button d-flex align-items-center justify-content-center"
        key={i}
        onClick={() => {
          localStorage.setItem('currentCate', JSON.stringify(prod));
          goCatePage(name, prod._id);
        }}
      >
        <span className="home-cate-button-text">{name}</span>
      </div>
    );
  });

  return (
    <div className="homeProduct">
      <h1 className="homeProductText">{t(`Shop By Category`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      <div className="home-category-div">{result}</div>
    </div>
  );
}
export default HomeCate;
